import SafeHtmlDirective from "./safe.html";

export const directivePlugin = {
  install(app) {
    app.directive("safe-html", SafeHtmlDirective);
  },
};

/*
 * Invoke the binding.value function on clicking outside el element.
 * - Optional arg (default = document.body) specifies the source to trigger the click outside event
 * - Optional modifiers (default = {stop: false, prevent:false, capture: false}) tells whether to stop propagation / use event capturing
 *    - Uses event capturing to avoid conflicts with stopPropagation used by other elements on click
 *    - See https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#event_capture
 *    - See https://www.kentor.dev/posts/detecting-clicks-outside-an-element-the-right-way/
 * e.g v-click-outside:#app.stop.capture="handleClose"
 * clicking outside the el will invoke handleClose() for the click capturing event and it will stop propagation
 */
export const clickOutsideDirective = {
  "click-outside": {
    beforeMount: (el, binding) => {
      const { arg, modifiers } = binding;
      const selector = arg ?? null;
      const { stop = false, prevent = false, capture = false } = modifiers ?? {};
      const listener = (event) => {
        // here I check that click was outside the el and his children
        if (!(el == event.target || el.contains(event.target))) {
          if (stop) {
            event.stopPropagation();
          }
          if (prevent) {
            event.preventDefault();
          }
          // and if it did, call method provided in attribute value
          binding.value(event);
        }
      };

      el.clickOutsideEvent = { listener, capture, selector };
      if (selector) {
        document.querySelector(selector)?.addEventListener("click", listener, capture);
      } else {
        document.body.addEventListener("click", listener, capture);
      }
    },
    unmounted: (el) => {
      const { listener, capture, selector } = el.clickOutsideEvent;
      if (selector) {
        document.querySelector(selector)?.removeEventListener("click", listener, capture);
      } else {
        document.body.removeEventListener("click", listener, capture);
      }
    },
  },
};
